import React, { useEffect } from "react";
import { useTheme } from "@/b2b/context/ThemeContext";
import PropTypes from "prop-types";
import SafeIcon from "@/assets/icons/safe-icon.svg";
import RBI from "@/assets/icons/RBI.svg";
import SafeIconN from "@/assets/icons/safe-icon.svg";
import { use } from "react";
import { BadgeHelpIcon } from "lucide-react";

export default function TextField({
  type,
  name,
  label,
  value,
  onChange,
  required,
  pattern,
  icon,
  consent,
  inputMode,
  maxLength,
  disabled,
  hint,
}) {
  const theme = useTheme();
  // console.log("Theme in textfield", theme);
  const isFilled = value && value !== "";

  const handleInput = (e) => {
    let inputValue = e.target.value;

    if (type === "number") {
      inputValue = inputValue.replace(/\D/g, "");
    } else if (pattern === "^[A-Za-z\\s]*$") {
      inputValue = inputValue.replace(/[^A-Za-z\s]/g, "");
    }

    if (maxLength && inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }

    onChange(inputValue);
  };

  useEffect(() => {
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      if (input.matches(":-webkit-autofill")) {
        if (!theme) {
          // No theme → white text
          input.style.setProperty(
            "-webkit-text-fill-color",
            "white",
            "important"
          );
        } else {
          // Theme → respect theme color
          input.style.setProperty(
            "-webkit-text-fill-color",
            "inherit",
            "important"
          );
        }
      }
    });
  }, [theme]);

  return (
    <div className="flex flex-col">
      <div className="relative flex flex-col h-14">
        <input
          type={type || "text"}
          name={name}
          autoComplete={name}
          id={name}
          data-theme={theme ? "true" : undefined}
          inputMode={inputMode || (type === "number" ? "numeric" : "text")}
          value={value}
          required={required}
          maxLength={maxLength}
          pattern={pattern}
          disabled={Boolean(disabled)}
          onInput={handleInput}
          className={`border p-4 text-base border-primary-500 
            ${theme?.backgroundColor || "bg-input-bg"} 
            ${theme?.textColor || "text-black"} 
            focus:outline-none w-full h-full 
            placeholder-transparent peer rounded-none peer
            ${
              isFilled
                ? theme?.textColor
                  ? theme?.textColor
                  : "text-white"
                : ""
            } 
            ${name === "pan" ? "uppercase" : ""}`}
          placeholder={`Enter ${label}`}
        />
        <label
          htmlFor={name}
          className={`absolute left-3 text-primary-500 transition-all duration-200
      peer-placeholder-shown:top-4 
      peer-placeholder-shown:text-base 
      peer-focus:text-sm peer-focus:-top-2 peer-focus:px-1
      ${theme?.backgroundColor ? theme?.peerFocusColor : "peer-focus:bg-input-bg"}
      ${
        isFilled
          ? `text-sm -top-2.5 ${
              theme?.backgroundColor
                ? `${theme?.textColor} ${theme?.backgroundColor}`
                : "text-blue-500 bg-[#050a17]"
            } px-1`
          : ""
      }
      pointer-events-none`}
        >
          {icon && <img src={icon} alt={label} />}
          {label}
        </label>
      </div>
      {hint && (
        <div className="flex justify-between items-end mt-2 text-xs w-full">
          <div className="flex items-center">
            <BadgeHelpIcon className="size-3" />
            <div className="flex gap-1 text-2xs ml-1">
              <span className="">{hint}</span>
            </div>
          </div>
        </div>
      )}
      {consent && (
        <div className="flex justify-between items-center mt-2 text-xs">
          <div className="flex items-center">
            <img src={SafeIconN} alt="safe-icon" className="scale-[73%]" />
            <div className="flex gap-1 text-2xs ml-1">
              <span className="">Your data is</span>
              <span className="text-green-500">100% safe</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// TextField.propTypes = {
//   name: PropTypes.string.isRequired,
//   label: PropTypes.string,
//   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   onChange: PropTypes.func,
//   required: PropTypes.bool,
//   pattern: PropTypes.string,
//   icon: PropTypes.string,
//   consent: PropTypes.bool,
//   inputMode: PropTypes.string,
//   maxLength: PropTypes.number,
//   disabled: PropTypes.bool,
// };
